import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/blacksmith-ui/cn";
import { SANDBOX_MARK_COLUMNS, SANDBOX_MARK_ROWS, fleetCellKind } from "./SandboxFleet";

/** The home tile's running / off-peak / idle tones as shades of the rail's icon color. */
const CELL_OPACITY = {
  running: 1,
  offPeak: 0.45,
  idle: 0.18
} as const;

/** Four 3.5-unit cells with 1-unit gaps span 17 of 18 units, so at 2x every edge lands on a device pixel. */
const CELL = 3.5;
const PITCH = 4.5;
const INSET = 0.5;
const WAVE_STEP_MS = 60;

/**
 * Rail glyph for Sandboxes: the home tile's fleet mark at icon size. Hovering
 * its rail row sends a boot wave across the cells, top-left to bottom-right.
 */
export function SandboxesIcon(t0) {
  const $ = _c(5);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("shrink-0", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = SANDBOX_MARK_ROWS.flatMap(_temp);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="currentColor" aria-hidden={true} className={t1}>{t2}</svg>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp(fleetRow, row) {
  return Array.from({
    length: SANDBOX_MARK_COLUMNS
  }, (_, column) => <rect key={`${row}-${column}`} x={INSET + column * PITCH} y={INSET + row * PITCH} width={CELL} height={CELL} rx={0.75} opacity={CELL_OPACITY[fleetCellKind(fleetRow, column)]} className="sandboxes-fleet-cell" style={{
    animationDelay: `${(row + column) * WAVE_STEP_MS}ms`
  }} />);
}